import React from 'react'
import PrivatePageSF from '../../templates/PrivatePageSF'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import GenericErrorUI from '../../components/common/GenericErrorUI'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'
import ProductItemListUI from '../../components/accountSettings/productItem/ProductItemListUI'
import ProductItemCreateModalSF from '../../components/accountSettings/productItem/ProductItemCreateModalSF'
import ProductItemUpdateModalSF from '../../components/accountSettings/productItem/ProductItemUpdateModalSF'
import SuccessMessageUI from "../../widgets/form/SuccessMessageUI";
import ErrorMessage2UI from "../../widgets/form/ErrorMessage2UI";

const ProductItemListPageUI = ({context, messageList, inventoryItemList, filteredProductItemList,
      // filters
      searchFilter, onSearchFilterChange,
      // form
      successMsg, errorMsgList, errorList, setErrorList,
      // modes
      selectedCount, updateMode, deleteMode, submitted, uploadSubmitted,
      // event handlers
      onRowClick, onRefreshClick, onCreateClick, onUpdateClick, onDeleteClick,
      // upload
      onUploadSubmit,
      // create product item
      onCreateProductItemClick, createProductItemMode, onCancelCreateProductItem, onCreateProductItemComplete,
      // update product item
      onUpdateProductItemClick, updateProductItemMode, onCancelUpdateProductItem, onUpdateProductItemComplete
}) =>
  <PrivatePageSF context={context} className='pg_acc_cust' backLink='/settings/account/fin'
    centered={!inventoryItemList || (errorList && errorList.length > 0)}
    messageList={messageList} headerMessageKey='c_product_items'>
    {
      !inventoryItemList && !(errorList && errorList.length) > 0 &&
      <SpinnerComponentUI />
    }
    {
      uploadSubmitted &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      errorMsgList && errorMsgList.length > 0 &&
      <ErrorMessage2UI className='msg' errorList={errorMsgList} />
    }
    {
      successMsg && successMsg.length > 0 &&
      <SuccessMessageUI successMsg={successMsg} />
    }
    {
      !uploadSubmitted && inventoryItemList && !(errorList && errorList.length) > 0 &&
      <div>
        <PageTitleUI context={context} goBack={true} backLink='/settings/account/fin' messageList={messageList} titleMessageKey='c_product_items' />
        <ProductItemListUI
          context={context}
          inventoryItemList={filteredProductItemList}
          messageList={messageList}
          searchFilter={searchFilter}
          onSearchFilterChange={onSearchFilterChange}
          //
          selectedCount={selectedCount}
          onRefreshClick={onRefreshClick}
          onCreateClick={onCreateProductItemClick}
          onUpdateClick={onUpdateProductItemClick}
          onDeleteClick={onDeleteClick}
          onRowClick={onRowClick}
          onUploadSubmit={onUploadSubmit}
        />
      </div>
    }
    <ProductItemCreateModalSF context={context} createMode={createProductItemMode}
      onCancelClick={onCancelCreateProductItem} onCreateComplete={onCreateProductItemComplete}
    />
    <ProductItemUpdateModalSF context={context} updateMode={updateProductItemMode}
      onCancelClick={onCancelUpdateProductItem} onUpdateComplete={onUpdateProductItemComplete}
      inventoryItemList={inventoryItemList}
    />
  </PrivatePageSF>

export default ProductItemListPageUI
